export default "__VITE_ASSET__f88fe8ad__"